import '../themeDefaults';

export default ({ formComponents }) => ({
  input: {
    ...formComponents.input,
    width: '100%',
    display: 'block',
    height: ({ textarea }) => (textarea
      ? formComponents.input.textareaHeight
      : formComponents.input.height
    ),
    borderColor: ({ error, dark, warning }) => !!error && (dark ? (
      warning ? formComponents.dark.warning.borderColor : formComponents.dark.error.borderColor
    ) : (
      warning ? formComponents.warning.borderColor : formComponents.error.borderColor
    )),
    color: ({ dark }) => (dark ? formComponents.dark.color : formComponents.input.color),
    backgroundColor: ({ dark }) => (dark
      ? formComponents.input.dark.backgroundColor
      : formComponents.input.backgroundColor
    ),

    '&:disabled': {
      cursor: 'not-allowed',
      backgroundColor: '#EDEDED',
      color: formComponents.input.color,
      opacity: 1
    },

    '&:focus': {
      outlineColor: ({ dark }) => (dark
        ? formComponents.input.darkFocusColor
        : formComponents.input.focusColor
      )
    }
  }
});
